// extracted by css-extract-rspack-plugin
export default {"tooltipBlock":"tooltipBlock-Vdgds6","tooltipTitle":"tooltipTitle-zRHCwL","tooltipMetrics":"tooltipMetrics-eIIydV"};